import React, { Component } from "react";
import {CSVLink} from 'react-csv';
import lodash from 'lodash';
import Table from '../../../../components/table';
import "./style.scss";
import { includes } from 'lodash';
import { connect } from "react-redux";
import {
    ACTIONS_PLAYER, getPlayerGamelog, converPlayerGamelogPitcher, converPlayerGamelogBatter,
    getPlayerGamelogPitcher, converPlayerGamelogItem1,
    getPlayerGamelogBatter, converPlayerGamelogItem2
} from './../../../../actions/player-gamelogs';
import {
    ACTIONS_MASTER, getYearData
} from './../../../../actions/master';
import Loading from "../../../../components/loading";

function buildCSV({pitcher, batter, titlePitcher, headerPitcher, titleBatter, headerBatter}) {
    const header1 = lodash.clone(headerPitcher);
    header1.shift();
    const lst1 = [
        [titlePitcher],
        header1
    ];

    const header2 = lodash.clone(headerBatter);
    header2.shift();
    const lst2 = [
        [titleBatter],
        header2
    ];
    pitcher.forEach(value => {
        const raw = lodash.clone(value.item || []);
        raw.shift();
        lst1.push(raw.map(item => item.teamName ? item.teamName: item.text));
    });

    batter.forEach(value => {
        const raw = lodash.clone(value.item || []);
        raw.shift();
        lst2.push(raw.map(item => item.teamName ? item.teamName: item.text));
    });
    // console.log('pitcher', pitcher);
    return [
        ...lst1,
        ...lst2,
    ];
}

class GameLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataPerformance: this.props.dataList1,
            dataResult: this.props.dataList2,
            arrAdd: [],
            arrAddResult: [],
            years: [],
            player_id: null,
            idYearSelect: 1936,
            nextPropsFirst: false,
            positionShowDataOfMonth: 0,
            nextPropsFirstPitcher: false,
            isNotSetstate: false,
            isNotShowChild: true,
            pos: 0,
            timeSelectedToggle: null,
            listCsv: [],
        }
    }

    componentDidMount() {
        const player_id = this.props.match.params.id;
        this.setState({
            player_id: +player_id,
            showLoading: true
        })
        this.props.getYearData();
        this.props.getPlayerGamelog(player_id, this.state.idYearSelect);
    }

    yearSelect(year) {
        let idYear = this.state.years.find(o => {
            return o.year === Number(year)
        }).year_id
        this.setState({
            idYearSelect: idYear,
            showLoading: true
        })
        this.props.getPlayerGamelog(this.state.player_id, idYear);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {


        if (nextProps) {

            if (nextProps.status === ACTIONS_PLAYER.GET_PLAYER_GAMELOG_SUCCESS) {
                const gameLogPitcher = converPlayerGamelogPitcher(nextProps.response) || [];
                const gameLogBatter = converPlayerGamelogBatter(nextProps.response) || [];
                const listCsv = buildCSV({
                    titlePitcher: this.props.titlePerformance.text,
                    headerPitcher: this.props.headerPerformance,
                    pitcher: gameLogPitcher,
                    titleBatter: this.props.titleResult.text,
                    headerBatter: this.props.headerResult,
                    batter: gameLogBatter,
                });
                this.setState({
                    dataPerformance: gameLogPitcher,
                    dataResult: gameLogBatter,
                    showLoading: false,
                    listCsv
                }, () => {

                    if (!this.state.nextPropsFirst) {
                        // this.handleClickIcon(this.state.dataPerformance);
                    }
                    this.setState({ nextPropsFirst: true })

                })
            } else {
                this.setState({
                    showLoading: false
                })
            }

            if (nextProps.status === ACTIONS_PLAYER.GET_PLAYER_GAMELOG_PITCHER_SUCCESS) {


                if (!this.state.nextPropsFirstPitcher) {
                    let position = this.state.positionShowDataOfMonth;
                    let arrNew = this.state.dataPerformance;
                    arrNew.forEach((o, index) => {
                        if (o.item[0].time === this.state.timeSelectedToggle) {
                            this.setState({
                                positionShowDataOfMonth: index
                            }, () => {
                                let arrNew1 = this.state.dataPerformance;
                                arrNew1.splice(index + 1, 0, ...converPlayerGamelogItem1(nextProps.response, position, this.state.timeSelectedToggle));
                                const listCsv = buildCSV({
                                    titlePitcher: this.props.titlePerformance.text,
                                    headerPitcher: this.props.headerPerformance,
                                    pitcher: arrNew1,
                                    titleBatter: this.props.titleResult.text,
                                    headerBatter: this.props.headerResult,
                                    batter: this.state.dataResult,
                                });

                                this.setState({
                                    dataPerformance: arrNew1,
                                    showLoading: false,
                                    listCsv,
                                })

                            })
                        }
                    })
                    this.setState({
                        nextPropsFirstPitcher: true
                    })
                }
            }

            if (nextProps.status === ACTIONS_PLAYER.GET_PLAYER_GAMELOG_BATTER_SUCCESS) {

                if (!this.state.nextPropsFirstPitcher) {
                    let position = this.state.positionShowDataOfMonth;
                    let arrNew = this.state.dataResult;
                    arrNew.forEach((o, index) => {
                        if (o.item[0].time === this.state.timeSelectedToggle) {
                            this.setState({
                                positionShowDataOfMonth: index
                            }, () => {
                                let arrNew1 = this.state.dataResult;
                                arrNew1.splice(index + 1, 0, ...converPlayerGamelogItem2(nextProps.response, position, this.state.timeSelectedToggle));
                                const listCsv = buildCSV({
                                    titlePitcher: this.props.titlePerformance.text,
                                    headerPitcher: this.props.headerPerformance,
                                    pitcher: this.state.dataPerformance,
                                    titleBatter: this.props.titleResult.text,
                                    headerBatter: this.props.headerResult,
                                    batter: arrNew1,
                                });
                                this.setState({
                                    dataResult: arrNew1,
                                    showLoading: false,
                                    listCsv
                                })
                            })
                        }
                    })
                    this.setState({
                        nextPropsFirstPitcher: true
                    })
                }
            }

            if (nextProps.responseYear && nextProps.responseYear !== this.state.years) {
                if (nextProps.statusYear === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                    this.setState({
                        years: nextProps.responseYear,
                        idYearSelect: nextProps.responseYear[0].year_id
                    })
                    this.props.getPlayerGamelog(this.props.match.params.id, nextProps.responseYear[0].year_id);
                }
            }
        }
    }

    resetAddData(data, e) {
        const body = {
            month_id: data.item[1].month_id,
            player_id: +this.state.player_id,
            year_id: +this.state.idYearSelect || 1936
        }
        if (data.table === 1) {

            if (includes(data.item[0].src, 'add')) {
                data.item[0].src = '/img/content/minus_24px.svg';
                this.setState({
                    timeSelectedToggle: data.item[0].time,
                    positionShowDataOfMonth: data.item[1].month_id,
                    nextPropsFirstPitcher: false,
                    showLoading: true
                })
                this.props.getPlayerGamelogPitcher(body);
            } else {
                data.item[0].src = '/img/content/add_24px.svg';
                let remain = this.state.dataPerformance.filter(v => {
                    return v.item[0].time_child !== data.item[0].time
                })
                this.setState({
                    dataPerformance: remain
                })
            }

        } else {

            if (includes(data.item[0].src, 'add')) {
                data.item[0].src = '/img/content/minus_24px.svg';
                this.setState({
                    timeSelectedToggle: data.item[0].time,
                    positionShowDataOfMonth: data.item[1].month_id,
                    nextPropsFirstPitcher: false,
                    showLoading: true
                })
                this.props.getPlayerGamelogBatter(body);

            } else {
                data.item[0].src = '/img/content/add_24px.svg';
                let remain = this.state.dataResult.filter(v => {
                    return v.item[0].time_child !== data.item[0].time
                })
                this.setState({
                    dataResult: remain
                })
            }

        }

    }

    render() {
		const { history } = this.props;
        return (
            <div className="gamelogs">
                <div className="gamelogs-control">
                    <select onChange={ev => this.yearSelect(ev.target.value)} className="form-control">
                        {
                            this.state.years.map((item, index) =>
                                <option key={index.toString()}>{item.year}</option>)
                        }
                    </select>

                    <div className="block-button">
                        <CSVLink className={'csv-download'}
                                 data={this.state.listCsv}
                                 filename={'gamelog.csv'}>
                            CSVダウンロード
                        </CSVLink>
                    </div>
                </div>
                <div className="gamelogs-content" id='player-gamelog'>
                    <div id="performance">
                        <Table
                            header={this.props.headerPerformance}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataPerformance}
                            isShowOptionTable={false}
                            titleTable={this.props.titlePerformance}
                            resetAddData={(data, e) => this.resetAddData(data, e)}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                        />
                    </div>
                    <div id="result">
                        <Table
                            header={this.props.headerResult}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataResult}
                            isShowOptionTable={false}
                            titleTable={this.props.titleResult}
                            resetAddData={(data, e) => this.resetAddData(data, e)}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                        />
                    </div>
                </div>

                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ playersGameLogs, master }) => {
    return {
        titlePerformance: playersGameLogs.titlePerformance,
        headerPerformance: playersGameLogs.headerPerformance,
        titleResult: playersGameLogs.titleResult,
        headerResult: playersGameLogs.headerResult,
        dataList1: playersGameLogs.dataList1,
        dataList2: playersGameLogs.dataList2,
        response: playersGameLogs.response,
        status: playersGameLogs.status,
        statusYear: master.status,
        responseYear: master.response
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getPlayerGamelog: (playerId, yearId) => {
            dispatch(getPlayerGamelog(playerId, yearId))
        },
        getPlayerGamelogPitcher: (data) => {
            dispatch(getPlayerGamelogPitcher(data))
        },
        getPlayerGamelogBatter: (data) => {
            dispatch(getPlayerGamelogBatter(data))
        },
        getYearData: () => {
            dispatch(getYearData());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(GameLogs);
